function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { httpGet } from 'buzz_lib_shared';
export class KeyResolver {
  constructor(infraApiUrl) {
    _defineProperty(this, "get", async key => {
      const endpoint = this.infraApiUrl === '' ? "/key" : "".concat(this.infraApiUrl, "buzz_fun_infrastructure_key");
      const result = await httpGet(endpoint, {
        key: key
      });
      return result[key];
    });
    _defineProperty(this, "getMany", async keys => {
      const endpoint = this.infraApiUrl === '' ? "/keys" : "".concat(this.infraApiUrl, "buzz_fun_infrastructure_key");
      const result = await httpGet(endpoint, {
        keys: keys.join()
      });
      return result;
    });
    this.infraApiUrl = infraApiUrl !== null && infraApiUrl !== void 0 ? infraApiUrl : '';
  }
}